<template>
    <div>
        <CheckboxSimple :markFormDirty="false" title="NFSe Nacional" v-model="configCompany.nacional" />
        <br>
        <div v-show="!configCompany.nacional">
            <b-row>
                <b-col sm="6">
                    <SelectStatic title="Natureza da Operação" :formName="formName" :required="true"
                        :initialValue="configCompany.naturezaOperacao" :data="optionsNaturezaOperacao"
                        v-model="configCompany.naturezaOperacao" />
                </b-col>
                <b-col sm="6">
                    <SelectStatic title="Código Indicador Operação" :formName="formName" :required="false"
                        :initialValue="configCompany.codigoIndicadorOperacao" :data="optionsCodigoIndicadorOperacao"
                        v-model="configCompany.codigoIndicadorOperacao" />
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <SelectStatic title="IBS/CBS Situação Tributária" :formName="formName" :required="false"
                        :initialValue="configCompany.ibsCbsSituacaoTributaria" :data="optionsTributacaoIBSCBS"
                        v-model="configCompany.ibsCbsSituacaoTributaria" />
                </b-col>
                <b-col sm="6">
                    <SelectStatic title="IBS/CBS Classificação Tributária" :formName="formName" :required="false"
                        :initialValue="configCompany.ibsCbsClassificacaoTributaria"
                        :data="optionsClassificacaoTributaria"
                        v-model="configCompany.ibsCbsClassificacaoTributaria" />
                </b-col>
            </b-row>
        </div>
        <div v-show="configCompany.nacional">
            <b-row>
                <b-col sm="6" v-if="ehSimplesNacional">
                    <SelectStatic title="Situação perante Simples Nacional" :required="true"
                        :initialValue="configCompany.codigoOpcaoSimplesNacional"
                        :data="optionsCodigoOpcaoSimplesNacional" v-model="configCompany.codigoOpcaoSimplesNacional" />
                </b-col>
                <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                    <SelectStatic title="Tipo de Tributação ISS" :formName="formName" :required="true"
                        :initialValue="configCompany.tipoTributacao" :data="optionsTipoTributacao"
                        v-model="configCompany.tipoTributacao" />
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6" v-if="ehSimplesNacional">
                    <SelectStatic title="Regime de Apuração Tributária pelo Simples Nacional" :required="true"
                        :initialValue="configCompany.regimeApuracaoTributariaSimplesNacional"
                        :data="optionsRegimeApuracaoTributariaSimplesNacional"
                        v-model="configCompany.regimeApuracaoTributariaSimplesNacional" />
                </b-col>
                <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                    <SelectStatic title="Regime Especial de Tributação Municipal" :required="true"
                        :initialValue="configCompany.regimeEspecialTributacaoMunicipal"
                        :data="optionsRegimeEspecialTributacaoMunicipal"
                        v-model="configCompany.regimeEspecialTributacaoMunicipal" />
                </b-col>
            </b-row>
            <b-row v-if="!ehSimplesNacional">
                <b-col sm="12">
                    <SelectStatic title=" Situação Tributária do PIS/COFINS" :formName="formName" :required="false"
                        :initialValue="configCompany.situacaoTributariaPisCofins" :data="optionsSituacaoTributariaPisCofins"
                        v-model="configCompany.situacaoTributariaPisCofins" />
                </b-col>
            </b-row>
        </div>
        <div>
            <b-row>
                <b-col sm="2">
                    <InputNumber title="Alíquota ISS %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.iss" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <InputNumber title="Alíquota PIS %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.pis" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <InputNumber title="Alíquota COFINS %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.cofins" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <InputNumber title="Alíquota CSLL %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.csll" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <InputNumber title="Alíquota INSS %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.inss" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <InputNumber title="Alíquota IR %" field="aliquota" type="float" :formName="formName"
                        :required="false" :maxLength="9" v-model="configCompany.ir" />
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="2">
                    <InputNumber title="IBS %" field="aliquota" type="float" :formName="formName" :required="false"
                        :maxLength="9" v-model="configCompany.ibs" />
                </b-col>
                <b-col sm="2">
                    <InputNumber title="CBS %" field="aliquota" type="float" :formName="formName" :required="false"
                        :maxLength="9" v-model="configCompany.cbs" />
                </b-col>
            </b-row>
        </div>
        <div>
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                    <InputNumber type="float" title="Federais %" field="percentualTotalTributosFederais" :maxLength="9"
                        v-model="configCompany.percentualTotalTributosFederais" />
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                    <InputNumber type="float" title="Estaduais %" field="percentualTotalTributosEstaduais" :maxLength="9"
                        v-model="configCompany.percentualTotalTributosEstaduais" />
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                    <InputNumber type="float" title="Municipais %" field="percentualTotalTributosMunicipais" :maxLength="9"
                        v-model="configCompany.percentualTotalTributosMunicipais" />
                </b-col>
            </b-row>
        </div>
        <div class="div-btn-save nfs-div-btn-save">
            <Button _key="btnSaveCompany" type="success" title="Salvar" classIcon="fas fa-save" size="medium"
                :clicked="saveCompany" />
        </div>
    </div>
</template>

<script>
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";

export default {
    name: "Imposto",
    components: {
        CheckboxSimple,
        InputNumber,
        Button,
        SelectStatic,
    },
    props: {
        configCompany: {
            type: Object,
            required: true,
        },
        ehSimplesNacional: {
            type: Boolean,
            required: true,
        },
        formName: {
            type: String,
            required: false,
            default: "",
        },
        optionsNaturezaOperacao: {
            type: Array,
            required: true,
        },
        optionsCodigoIndicadorOperacao: {
            type: Array,
            required: true,
        },
        optionsTributacaoIBSCBS: {
            type: Array,
            required: true,
        },
        optionsClassificacaoTributaria: {
            type: Array,
            required: true,
        },
        optionsCodigoOpcaoSimplesNacional: {
            type: Array,
            required: true,
        },
        optionsTipoTributacao: {
            type: Array,
            required: true,
        },
        optionsRegimeApuracaoTributariaSimplesNacional: {
            type: Array,
            required: true,
        },
        optionsRegimeEspecialTributacaoMunicipal: {
            type: Array,
            required: true,
        },
        optionsSituacaoTributariaPisCofins: {
            type: Array,
            required: true,
        },
        saveCompany: {
            type: Function,
            required: true,
        },
    }
};
</script>